import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../../store/config';
import {
  BunkReaderFormValues,
  DeleteFeedingPayload,
  Group,
  GroupCreatePayload,
  GroupEditPayload,
  GroupNote,
  GroupsEditPayload,
} from './group.types';
import { BunkScoresResponse } from '../settings/settings.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/group');

export const getGroupList = actionCreator.async<{}, Group[]>('GET_GROUP_LIST');
export const getAllGroups = actionCreator.async<{}, Group[]>('GET_ALL_GROUPS');
export const getGroupById = actionCreator.async<{}, Group>('GET_GROUP_DETAIL_BY_ID');
export const getBunkReaderGroupById = actionCreator.async<string, Group>('GET_BUNK_READER_GROUP_BY_ID');
export const addBunkScores = actionCreator.async<keyof BunkReaderFormValues | null, BunkScoresResponse>(
  'ADD_BUNK_SCORES',
);
export const addBunkReaderGroupNote = actionCreator.async<
  { groupId: string; note: Partial<GroupNote> },
  { groupId: string; note: GroupNote }
>('ADD_BUNK_READER_GROUP_NOTE');
export const editBunkReaderGroupNote = actionCreator.async<
  { groupId: string; note: GroupNote },
  { groupId: string; note: GroupNote }
>('EDIT_BUNK_READER_GROUP_NOTE');
export const deleteBunkReaderGroupNote = actionCreator.async<{ groupId: string; noteId: string }, void>(
  'DELETE_BUNK_READER_GROUP_NOTE',
);
export const addGroup = actionCreator.async<GroupCreatePayload, Group>('ADD_GROUP');
export const editGroup = actionCreator.async<GroupEditPayload, Group>('EDIT_GROUP');
export const editGroups = actionCreator.async<GroupsEditPayload, Group[]>('EDIT_GROUPS');
export const updateGroup = actionCreator.async<FormName, Group>('UPDATE_GROUP');
export const deleteGroup = actionCreator.async<FormName, string>('DELETE_GROUP');
export const deleteFeedingGroup = actionCreator.async<{}, Group>('DELETE_FEEDING_GROUP');
export const deleteFeeding = actionCreator.async<DeleteFeedingPayload, void>('DELETE_FEEDING');
export const editAdditionalCostsInGroup = actionCreator.async<{}, Group>('EDIT_ADDITIONAL_COSTS_IN_GROUP');
